(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-benefits-tabs"] && !Shopify.designMode) return;
  try {
    
  /* ADA-053: WAI-ARIA tabs pattern – click, Enter/Space, Left/Right arrows, Home/End.
     Runs immediately if the DOM is already parsed (section JS bundles load late). */
  (function () {
    function initTabs() {
      document.querySelectorAll('.tabs-container [role="tablist"]').forEach(function (tabList) {
        if (tabList.dataset.a11yTabs) return;
        tabList.dataset.a11yTabs = 'true';
        var tabs = Array.prototype.slice.call(tabList.querySelectorAll('[role="tab"]'));
        var container = tabList.parentNode;

        function activate(tab, setFocus) {
          tabs.forEach(function (t) {
            var selected = t === tab;
            t.setAttribute('aria-selected', selected ? 'true' : 'false');
            t.setAttribute('tabindex', selected ? '0' : '-1');
            var panel = container.querySelector('#' + t.getAttribute('aria-controls'));
            if (panel) { if (selected) panel.removeAttribute('hidden'); else panel.setAttribute('hidden', ''); }
          });
          if (setFocus) tab.focus();
        }

        tabs.forEach(function (tab, index) {
          tab.addEventListener('click', function () { activate(tab, false); });
          tab.addEventListener('keydown', function (e) {
            var next = null;
            if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = tabs[(index + 1) % tabs.length];
            else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = tabs[(index - 1 + tabs.length) % tabs.length];
            else if (e.key === 'Home') next = tabs[0];
            else if (e.key === 'End') next = tabs[tabs.length - 1];
            if (next) { e.preventDefault(); activate(next, true); }
          });
        });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTabs);
    else initTabs();
    document.addEventListener('shopify:section:load', initTabs);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-ingredients"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const accordionItems = document.querySelectorAll('.ingredient__accordion');

    let activeAccordion = null;

    accordionItems.forEach((item) => {
      const content = item.querySelector(
        '.ingredient_accordion__content'
      );
      const button = item.querySelector(
        '.ingredient_accordion__header'
      );

      button.addEventListener('click', function () {
        const isExpanded = button.getAttribute('aria-expanded') === 'true';

        // 1. Close all other accordions (Single-open behavior)
        accordionItems.forEach((otherItem) => {
          if (otherItem !== item) {
            const otherButton = otherItem.querySelector('.ingredient_accordion__header');
            const otherContent = otherItem.querySelector('.ingredient_accordion__content');
            
            otherButton.setAttribute('aria-expanded', 'false');
            otherContent.style.height = '0px';
          }
        });

        // 2. Toggle current accordion
        if (isExpanded) {
          button.setAttribute('aria-expanded', 'false');
          content.style.height = '0px';
        } else {
          button.setAttribute('aria-expanded', 'true');
          content.style.height = content.scrollHeight + 'px';
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
